import { SERVER_API_URL, ROBOT_API_URL } from "@/constants";

const baseUrl = `${SERVER_API_URL}/api`;
const robotUrl = `${ROBOT_API_URL}/api`;

export const account = {
  ACTIVATION_EMAIL_URL: `${baseUrl}/activationmail`,
  AUTHENTICATE_URL: `${baseUrl}/authenticate`,
  ACCOUNT_URL: `${baseUrl}/account`,
  RESET_PASSWORD_INIT_URL: `${baseUrl}/account/reset-password/init`,
  RESET_PASSWORD_FINISH_URL: `${baseUrl}/account/reset-password/finish`,
  ACCOUNT_ACTIVATE_URL: `${baseUrl}/account/activate`,
  PRIVACY_ACTIVATE_URL: `${baseUrl}/privacy-activate`,
  USERDATA_URL: `${baseUrl}/account/userdata`,
  PRIVACY_PAGE_URL: `${robotUrl}/base/uni/Azienda/privacyconfirm`,
  PRIVACY_URL: `${robotUrl}/base/uni/Azienda/privacy`,
};

export const proxy = {
  UPLOAD_DOCUMENT_URL_1: `${robotUrl}/lavoro/pag/documentidip/upload`,
  UPLOAD_DOCUMENT_URL_2: `${robotUrl}/base/uni/DocBase/uploaddoc`,
  NUM_DOC_NUOVI_URL: `${robotUrl}/lavoro/pag/dipendente/numDocumentiDipNuovi`,
};

export const documents = {
  FETCH_PAYROLLS_URL: `${robotUrl}/lavoro/pag/cedolino/cedolinidipendente-download`,
  FETCH_CUDS_URL: `${robotUrl}/lavoro/pag/dipendente/cudDipendente-download`,
  FETCH_DOCUMENTS_URL: `${robotUrl}/lavoro/pag/dipendente/documentidipendente-download`,
  DOWNLOAD_DOCUMENT_URL: `${robotUrl}/lavoro/pag/dipendente/documento-download`,
  DOWNLOAD_CUD_URL: `${robotUrl}/lavoro/pag/dipendente/cud-download`,
  DOWNLOAD_PAYROLL_URL: `${robotUrl}/lavoro/pag/cedolino/cedolino-download`,
  FETCH_PAYROLL_URL: `${robotUrl}/lavoro/pag/doccedolino/bydocbase`,
};

export const employee = {
  FETCH_NOTICES_URL: `${baseUrl}/my-notices`,
  NUM_AVVISI_NUOVI_URL: `${baseUrl}/my-notices-unread-count`,

  CREATE_REQUESTS_URL: `${robotUrl}/base/uni/docrichiesta/upload`,
  FETCH_REQUESTS_URL: `${robotUrl}/base/uni/docrichiesta/lista`,
  DOWNLOAD_REQUEST_URL: `${robotUrl}/base/uni/docrichiesta/download`,

  FETCH_YEARDATA_URL: `${robotUrl}/lavoro/pag/cedolino/cedriepannuo`,
  FETCH_PROFILE_URL: `${robotUrl}/lavoro/pag/dipendente/lastactive`,
};
